import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { AnimatePresence, motion } from "framer-motion";

const FloatingCart = () => {
  const { cart } = useContext(CartContext);
  const totalItems = cart.items
    .filter((i) => !i.isGift)
    .reduce((total, item) => total + item.qty, 0);
  const [isVisible, setIsVisible] = useState(false);
  const prevItems = useRef(totalItems);

  const location = useLocation();
  const hiddenRoutes = ["/checkout", "/cart", "/login", "/register"];
  const isHidden = hiddenRoutes.includes(location.pathname);

  useEffect(() => {
    if (isHidden) {
      setIsVisible(false);
      return;
    }
    // Chỉ hiện khi số lượng tăng lên (không hiện khi vừa load trang)
    if (totalItems > prevItems.current) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 10000); // Hiện trong 10 giây rồi ẩn

      return () => clearTimeout(timer);
    }
    prevItems.current = totalItems;
  }, [totalItems, isHidden]);

  return (
    <AnimatePresence>
      {isVisible && totalItems > 0 && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5, y: 50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 50 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          className="fixed bottom-24 sm:bottom-24 left-6 z-[9999]"
        >
          <Link
            to="/cart"
            className="relative flex items-center justify-center w-14 h-14 bg-blue-600 text-white rounded-full shadow-[0_8px_30px_rgb(37,99,235,0.4)] hover:bg-blue-700 hover:scale-110 active:scale-95 transition-all group"
          >
            <svg
              className="w-7 h-7 group-hover:rotate-12 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            <span className="absolute -top-1 -right-1 flex items-center justify-center min-w-[22px] h-[22px] px-1.5 bg-red-600 text-white text-[11px] font-black rounded-full border-2 border-white animate-pulse">
              {totalItems}
            </span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingCart;
